// extracted by mini-css-extract-plugin
export default {"root":"fileDownloadCellRenderer_root__-dbMQ","fileIcon":"fileDownloadCellRenderer_fileIcon__-53Ll"};